import type { FaireProductEntity } from "../../entity_types/product";

export const p_cqa7srdszz: FaireProductEntity = {
  token: "p_cqa7srdszz",
  type: "product",
  name: "Butter Dishcloth Set",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/1a319aa8291387b5cd8009c9bd06738800c32c79678978a3fd2c391968a29aef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f6ccf82864f1aafafee94edbcc324e6d07672b6382f5021724e4dbbeac7f3da1.jpeg"
  ],
  priceDollars: 7,
  description: "Dishcloth Set - 3 Pack\n\nDish it out. \n\nOur Dishcloths are everything you love about the original Geometry Kitchen Towel – in mini-size! Scrub, wipe, shine and repeat – our fast-drying, super-absorbent dishtowels can handle your biggest messes with ease (and a whole lot of style). Created from our signature Geoweave(™) fabric, perfect for surface cleaning and shining. Sold as a set of 3.\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * 10\" x 10\" \n * Single-sided print \n * Sold as a set of 3 \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\nChore responsibly. \n\nFrom scrubbing pots and pans to wiping up spills to accenting your kitchen with the season’s most captivating prints, our Dishcloth Sets will be your constant companion – and they’re a friend to the environment too. Our towels are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. And due to its patented weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours. \n",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:44.098Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
